export const HIGH_LEVEL_ROW_BACKGROUND_COLOR = '#bac8d3';

export const COURSE_CLASSIFICATION_ALL_YOU_CAN_EAT = 1;
export const COURSE_CLASSIFICATION_ALL_YOU_CAN_DRINK = 2;

export const DINE_IN = 0;
export const TAKE_OUT = 1;
export const SALES_CHANNEL_SOURCE: { [key: number]: string } = {
  [DINE_IN]: '店内',
  [TAKE_OUT]: 'テイクアウト',
};
